import { userProfileConstants } from '../../_constants';
import { userProfileService } from '../../_services';
import { userProfileAction } from './getUserProfile.action';

export const updateAdditionalInfoAction = {
    updateAdditionalInfoHandler
};

function updateAdditionalInfoHandler(data) {
    return dispatch => {
        dispatch(request());
        userProfileService.updateAdditionalInfoHandler(data)
            .then(
                updateAdditionalInfo => {
                    dispatch(userProfileAction.getUserProfileHandler())
                    dispatch(success(updateAdditionalInfo));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: userProfileConstants.REQUEST_UPDATE_ADDITIONAL_INFO} }
    function success(updateAdditionalInfo) { return { type: userProfileConstants.RECEIVE_UPDATE_ADDITIONAL_INFO, updateAdditionalInfo } }
    function failure(error) { return { type: userProfileConstants.UPDATE_ADDITIONAL_INFO_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/UserProfile/updateAdditionalInfo.action.js